/* Hold-to-confirm — réserver devient un geste : maintenir 650ms, le laiton se verse. */
(function () {
  'use strict';
  if (window.__mwHold) return; window.__mwHold = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (window.mwSettings && window.mwSettings.motionEnabled === false);
  var DUR = 650;
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    document.querySelectorAll('[data-hold-confirm]').forEach(function (btn) {
      if (reduce || !window.matchMedia('(pointer: fine)').matches) return; /* tactile + reduced = clic normal */
      btn.classList.add('mw-hold');
      var fill = document.createElement('span');
      fill.className = 'mw-hold__fill'; fill.setAttribute('aria-hidden', 'true');
      btn.appendChild(fill);
      var t = null, done = false;
      btn.addEventListener('click', function (e) { if (!done) e.preventDefault(); done = false; });
      btn.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        btn.classList.add('is-holding');
        t = window.setTimeout(function () {
          done = true; btn.classList.remove('is-holding'); btn.classList.add('is-confirmed');
          if (btn.form && btn.type === 'submit') { btn.form.requestSubmit(btn); } else { btn.click(); }
        }, DUR);
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
        btn.addEventListener(ev, function () { if (t) { clearTimeout(t); t = null; } btn.classList.remove('is-holding'); });
      });
      /* clavier : Enter/Espace = action immédiate, pas de hold (a11y) */
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { done = true; } });
      btn.setAttribute('title', 'Press and hold to confirm');
    });
  });
})();
